export const requestPermission = async () => {
    if (!('serviceWorker' in navigator) || !('Notification' in window)) return null;

    try {
        const permission = await window.Notification.requestPermission();
        if (permission !== 'granted') return null;
        return await navigator.serviceWorker.ready;
    } catch (e) {
        return null;
    }
};

export default {
    requestPermission,
};
